var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "onnit-ui/lib/box/Box";
import OOSView from "./shared/OOSView";
import DiscontinuedView from "./shared/DiscontinuedView";
import { getProductStatus } from "./utils";
import { ProductStatus } from "../@types/enums/ProductStatus";
function SingleProductBuyBox(_a) {
    var _b;
    var renderInStockView = _a.renderInStockView, product = _a.product, rest = __rest(_a, ["renderInStockView", "product"]);
    if (!product) {
        return null;
    }
    var productStatus = getProductStatus(product);
    return (React.createElement(Box, __assign({}, rest), (_b = {},
        _b[ProductStatus["InStock"]] = renderInStockView(product),
        _b[ProductStatus["OutOfStock"]] = React.createElement(OOSView, { product: product }),
        _b[ProductStatus["Discontinued"]] = React.createElement(DiscontinuedView, null),
        _b)[productStatus]));
}
export default SingleProductBuyBox;
//# sourceMappingURL=SingleProductBuyBox.js.map